const items = document.querySelectorAll(".header__inline-menu details");
let timeout; // Variabile per gestire il ritardo

for (const item of items) {
  const megaMenu = item.querySelector(".header__submenu"); // Sostituisci con il selettore corretto del mega menu

  // Apertura immediata su mouseover
  item.addEventListener("mouseenter", () => {
    clearTimeout(timeout); // Evita la chiusura se si passa rapidamente tra i menu
    items.forEach((otherItem) => {
      if (otherItem !== item) {
        otherItem.removeAttribute("open");
      }
    });
    item.setAttribute("open", true);
  });

  // Ritardo nella chiusura su mouseleave
  item.addEventListener("mouseleave", () => {
    timeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 300); // Ritardo modificabile
  });

  // Chiusura immediata se il cursore esce dalla parte inferiore del mega menu
  if (megaMenu) {
    megaMenu.addEventListener("mouseleave", () => {
      clearTimeout(timeout); // Annulla il ritardo
      item.removeAttribute("open"); // Chiudi immediatamente
    });
  }
}
